


















































































































































import Vue from "vue";
import { uuid } from "@/utils/uuid";
import KeysEdit from "@/components/PrjConfig/KeysEdit.vue";
import ConfigsEdit from "@/components/PrjConfig/ConfigsEdit.vue";
import KeyInfo from "@/components/PrjConfig/KeyInfo.vue";
import ConfigInfo from "@/components/PrjConfig/ConfigInfo.vue";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { eventBus } from "../utils/event";

const KeysHeaders: Header[] = [
  { title: "名称", key: "" },
  { title: "类型", key: "" },
  { title: "创建人", key: "" },
  { title: "创建时间", key: "createTime", minWidth: 180 },
  { title: "操作", key: "", width: 100 }
];

const ConfigsHeaders: Header[] = [
  { title: "名称", key: "name" },
  { title: "创建人", key: "createBy" },
  { title: "创建时间", key: "createTime", minWidth: 180 },
  { title: "操作", key: "", width: 100 }
];

const Tabs = [
  { label: "密钥", name: "Keys", uuid: uuid() },
  { label: "配置", name: "Config", uuid: uuid() }
];

export default Vue.extend({
  name: "PrjConfig",
  components: { KeysEdit, KeyInfo, ConfigsEdit, ConfigInfo },
  props: { projectId: { type: String } },
  data() {
    return {
      tabAcitve: "Keys",
      Tabs,
      KeysHeaders,
      ConfigsHeaders
    };
  },
  computed: {
    ...mapState("LoginInfo", ["userinfo"]),
    ...mapState("PrjConfig/Keys", {
      keysPages: "pages",
      keysPageNum: "pageNum",
      keysTotal: "total",
      keysFilterValue: "filterValue",
      keysLoading: "loading",
      keyHasNext: "hasNext"
    }),
    ...mapState("PrjConfig/Configs", {
      configsTableData: "tableData",
      configsFilterValue: "filterValue",
      configsLoading: "loading",
      configHasNext: "hasNext",
      configPages: "pages",
      configPageNum: "pageNum",
      configTotal: "total"
    }),
    ...mapGetters("PrjConfig/Keys", { keysTableData: "tableData" }),
    filterValue() {
      // @ts-ignore
      return this.tabAcitve === "Keys"
        ? this.keysFilterValue
        : this.configsFilterValue;
    }
  },
  watch: {
    projectId: {
      immediate: true,
      handler(val: string) {
        if (this.tabAcitve === "Keys") {
          // @ts-ignore
          this.keysGetData(`&projectId=${val}`);
        } else {
          // @ts-ignore
          this.configsGetData(val);
        }
      }
    },
    tabAcitve: {
      immediate: true,
      handler(val: string) {
        if (val === "Keys") {
          // @ts-ignore
          this.keysGetData(`&projectId=${this.projectId}`);
        } else {
          // @ts-ignore
          this.configsGetData(this.projectId);
        }
      }
    }
  },
  methods: {
    ...mapActions("PrjConfig/Keys", {
      keysGetData: "getData",
      keysDelete: "delete",
      keysSearch: "search",
      keysTurnPage: "turnPage"
    }),
    ...mapActions("PrjConfig/Configs", {
      configsGetData: "getData",
      configsDelete: "delete",
      configsSearch: "getData"
    }),
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;

        case "delete":
          this.del(data.metadata.name);
          break;
      }
    },
    create(data: any) {
      if (this.tabAcitve === "Keys") {
        (this.$refs.keys as any)?.show(data);
      } else {
        (this.$refs.configs as any)?.show(data);
      }
    },
    del(name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        const data = `?name=${name}&projectId=${this.projectId}`;
        // @ts-ignore
        if (this.tabAcitve === "Keys") {
          // @ts-ignore
          this.keysDelete({ data, append: `&projectId=${this.projectId}` });
        } else {
          // @ts-ignore
          this.configsDelete({
            projectId: this.projectId,
            name: name
          });
        }
      });
    },
    search(value: string) {
      // @ts-ignore
      if (this.tabAcitve === "Keys") {
        // @ts-ignore
        this.keysSearch({ value, append: `&projectId=${this.projectId}` });
      } else {
        // @ts-ignore
        this.configsSearch(this.projectId);
      }
    },
    // 查看密钥详情
    showKeyInfo(data: any) {
      eventBus.$emit("setBeard", {
        name: "密钥详情",
        callback: () => {
          (this.$refs.keyInfo as any).close();
        }
      });
      (this.$refs.keyInfo as any)?.show(data);
    },
    // 查看配置详情
    showConfigInfo(data: any) {
      eventBus.$emit("setBeard", {
        name: "配置详情",
        callback: () => {
          (this.$refs.configInfo as any).close();
        }
      });
      (this.$refs.configInfo as any)?.show(data);
    }
  }
});
